import styled from 'styled-components'
import { colors, fontWeights, breakpoints } from '@/styles'

export const Wrapper = styled.div`
  padding-bottom: 100px;

  > * {
    margin-bottom: 50px;
  }

  @media only screen and (max-width: ${breakpoints.ipadMiniMax}) {
    padding: 20px 0 100px;
  }
`

export const FormStack = styled.div`
  > div {
    margin-bottom: 50px;
  }

  > h2 {
    margin-bottom: 30px;
  }
`

export const FormGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 16px 24px;

  @media only screen and (max-width: ${breakpoints.phoneMax}) {
    grid-template-columns: 1fr;
  }

  ${props =>
    props.span &&
    `
    grid-column: 1 / -1;
  `}
`

export const FormRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  grid-column: 1 / -1;
`

export const SectionTitle = styled.h2`
  color: ${colors.darkGrey};
  font-size: 26px;
  font-weight: ${fontWeights.bold};
  letter-spacing: -0.2px;
  line-height: 36px;
`

export const SectionSubtitle = styled.h3`
  color: ${colors.regular};
  font-size: 20px;
  font-weight: ${fontWeights.bold};
  line-height: 28px;
  grid-column: 1 / -1;

  ${props =>
    props.small &&
    `
    font-size: 13px;
    letter-spacing: -0.08px;
    line-height: 18px;
    font-weight: ${fontWeights.regular};
  `}
`
